import { Balancer } from "react-wrap-balancer";

export const BalancedStepTitle = ({ title }: { title: string }) => {
  return (
    <h2 className="tw-text-xl">
      <Balancer>{title}</Balancer>
    </h2>
  );
};
